import { render, staticRenderFns } from "./TemporalDiscreteGraph.vue?vue&type=template&id=56972794&scoped=true"
import script from "./TemporalDiscreteGraph.vue?vue&type=script&lang=js"
export * from "./TemporalDiscreteGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56972794",
  null
  
)

export default component.exports